import React from "react";
import { withStyles, Grid, Button } from "@material-ui/core";
import { compose } from "recompose";
import MilesPopup from "./MilesPopup";
import RouteStopInfo from "./RouteStopInfo";

const styles = (theme) => ({
  smallText: {
    fontWeight: "600",
    fontSize: theme.headerTextFontSize,
    lineHeight: "22px",
    textDecorationLine: "underline",
    color: theme.stopNameColor,
  },
  headerText: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    lineHeight: "21px",
    margin: "19px 0px 10px 0px",
  },
  topPadding: {
    paddingTop: "7%",
  },
  stopDetailsButton: { position: "relative", top: "45px", left: "32px" },
  flexRowCenter: {
    display: "flex",
    alignItems: "center",
  },
});

const RouteStopDetails = ({ classes, routeDeviationData, stopChange }) => {
  return (
    <React.Fragment>
      {routeDeviationData.length > 0 &&
        routeDeviationData.map((stopDetails, index) => (
          <Grid
            container
            className={classes.topPadding}
            key={`${index}stopDetails`}
          >
            <Grid container>
              <div className={classes.flexRowCenter}>
                <div className={classes.smallText}>
                  {`At ${stopDetails.data.displayCustomerName}`}
                </div>
                {stopDetails.milesAdded !== 0 && (
                  <MilesPopup milesAdded={stopDetails.milesAdded} />
                )}
              </div>
            </Grid>
            <Grid container>
              <Grid item xs={4}>
                <div className={classes.headerText}>Planned Next Stop</div>
                {stopDetails.plannedNextStop?.data && (
                  <RouteStopInfo stopDetails={stopDetails.plannedNextStop} />
                )}
              </Grid>
              <Grid item xs={4}>
                <div className={classes.headerText}>Actual Next Stop</div>
                {stopDetails.actualNextStop?.data && (
                  <RouteStopInfo stopDetails={stopDetails.actualNextStop} />
                )}
              </Grid>
              <Grid item xs={4}>
                <div className={classes.stopDetailsButton}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => stopChange(stopDetails.stopSequence)}
                  >
                    View Stop Details
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        ))}
    </React.Fragment>
  );
};
export default compose(withStyles(styles))(RouteStopDetails);
